import { Environment } from './enviroment.model';

export const environment: Environment = {
    production: true,
    apiURL: 'https://login.hippodata.de/api/',
    loginInitials: '',
    loginPassword: '',
    isTestSystem: false,
};
